<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 10L5 4.16667"
      stroke="url(#paint0_linear_1_39649)"
      stroke-width="1.5"
      stroke-linecap="round"
      class="stroke"
    />
    <path
      d="M10 6.66406L10 4.16406"
      stroke="url(#paint1_linear_1_39649)"
      stroke-width="2"
      stroke-linecap="round"
      class="stroke"
    />
    <path
      d="M5 15.8359L5 13.3359"
      stroke="url(#paint2_linear_1_39649)"
      stroke-width="2"
      stroke-linecap="round"
      class="stroke"
    />
    <path
      d="M15 15.8359L15 14.1693"
      stroke="url(#paint3_linear_1_39649)"
      stroke-width="2"
      stroke-linecap="round"
      class="stroke"
    />
    <path
      d="M10 15.8359L10 10.0026"
      stroke="url(#paint4_linear_1_39649)"
      stroke-width="1.5"
      stroke-linecap="round"
      class="stroke"
    />
    <path
      d="M8.33301 6.66406L11.6663 6.66406"
      stroke="url(#paint5_linear_1_39649)"
      stroke-width="1.5"
      stroke-linecap="round"
      class="stroke"
    />
    <path
      d="M3.33301 13.3359L6.66634 13.3359"
      stroke="url(#paint6_linear_1_39649)"
      stroke-width="1.5"
      stroke-linecap="round"
      class="stroke"
    />
    <path
      d="M13.333 14.1641L16.6663 14.1641"
      stroke="url(#paint7_linear_1_39649)"
      stroke-width="1.5"
      stroke-linecap="round"
      class="stroke"
    />
    <path
      d="M15 10.8359L15 4.16927"
      stroke="url(#paint8_linear_1_39649)"
      stroke-width="1.5"
      stroke-linecap="round"
      class="stroke"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_39649"
        x1="5"
        y1="7.08333"
        x2="6"
        y2="7.08333"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_39649"
        x1="10"
        y1="5.41406"
        x2="11"
        y2="5.41406"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_39649"
        x1="5"
        y1="14.5859"
        x2="6"
        y2="14.5859"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1_39649"
        x1="15"
        y1="15.0026"
        x2="16"
        y2="15.0026"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1_39649"
        x1="10"
        y1="12.9193"
        x2="11"
        y2="12.9193"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1_39649"
        x1="9.99967"
        y1="6.66406"
        x2="9.99967"
        y2="7.66406"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1_39649"
        x1="4.99967"
        y1="13.3359"
        x2="4.99967"
        y2="14.3359"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1_39649"
        x1="14.9997"
        y1="14.1641"
        x2="14.9997"
        y2="15.1641"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1_39649"
        x1="15"
        y1="7.5026"
        x2="16"
        y2="7.5026"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style scoped>
svg .stroke {
  stroke: #df252a;
}
</style>
